export const ENTRY_POINT = "https://prod.api2.logistique.3bimport.fr";
export const APP_NAME = "ExterieurStock - Logistique";
//export const VIEW_PIN = true;